import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["content", "toggleButton"]

  connect() {
    // Initialize as collapsed
    this.collapsed = true
  }

  toggle() {
    this.collapsed = !this.collapsed
    
    if (this.collapsed) {
      this.collapse()
    } else {
      this.expand()
    }
  }

  expand() {
    this.contentTarget.classList.remove("hidden")
    // Rotate chevron up
    this.toggleButtonTarget.querySelector("svg").style.transform = "rotate(180deg)"
  }

  collapse() {
    this.contentTarget.classList.add("hidden")
    // Rotate chevron down
    this.toggleButtonTarget.querySelector("svg").style.transform = "rotate(0deg)"
  }
} 